import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsuarioService } from '@account/usuario.service';
import { ParametrosImpositivosService } from '@facturacion/parametros-impositivos.service';
import { CondicionVentaFactura } from '@shared/enums/condicionVentaFactura';
import { Balance7ActaDocumentosDTO } from '@shared/models/cierreTurno/Balance7ActaDocumentosDTO';
import { Balance7ActaDTO } from '@shared/models/cierreTurno/FechaDto';
import { TipoMovimiento } from '@shared/models/facturacion/TipoMovimiento';
import { SharedService } from '@shared/shared.service';

@Component({
  selector: 'app-generar-acta',
  templateUrl: './generar-acta.component.html',
  styleUrls: ['./generar-acta.component.scss'],
  providers: [DecimalPipe]
})
export class GenerarActaComponent implements OnInit {

  @Input() datosGeneralesActa: Balance7ActaDTO[];
  @Input() datosFacturacionActa: Balance7ActaDocumentosDTO[];
  @Input() mes: number;
  @Input() anio: number;

  obteniendoDatos: boolean ;

  nombreAeroplanta: string;
  fechaHoraActual: Date;
  nombreCiudad: string;

  constructor(private spinner: NgxSpinnerService,
              private usuarioService: UsuarioService,
              private decimalPipe: DecimalPipe,
              private parametroService: ParametrosImpositivosService,
              private sharedService: SharedService
              ) { }

  ngOnInit(): void {
    this.nombreAeroplanta = this.usuarioService.getAeroplantaActual().nombre;

    this.obtenerCiudadAeroplanta();

    this.fechaHoraActual = new Date();
  }

  obtenerCiudadAeroplanta(){
    const ciudadId = this.usuarioService.getAeroplantaActual().ciudadId;
    
    this.mostrarLoading();

    this.parametroService.obtenerLocalidades()
    .subscribe(localidades => {
      const localidad = localidades.filter(l => l.id.toUpperCase() == ciudadId.toUpperCase())[0];

      this.nombreCiudad = localidad.nombre;
      
      this.ocultarLoading();
    }, () => {this.ocultarLoading();});
  }

  getDescripcionUnidadMedida(unMed: number){
    let descripcion = "";

    if(unMed == 0){
      descripcion = "Unidades";
    } else if(unMed == 1 ){
      descripcion = "Litros";
    }    else if(unMed == 2 ){
      descripcion = "Kilogramos";
    } else if(unMed == 3 ){
      descripcion = "Libras";
    } else if(unMed == 4 ){
      descripcion = "Galon";
    }
    return descripcion;
  }

  getDescripcionComprobante(dato: Balance7ActaDocumentosDTO){
    let descripcion = "";

    if(dato.tipoMovimiento == TipoMovimiento.FAA){
      descripcion += "Factura tipo 'A' ";
    }else if(dato.tipoMovimiento == TipoMovimiento.FAB){
      descripcion += "Factura tipo 'B' ";
    }else if(dato.tipoMovimiento == TipoMovimiento.NCA){
      descripcion += "Nota Credito tipo 'A' ";
    }else if(dato.tipoMovimiento == TipoMovimiento.NCB){
      descripcion += "Nota Credito tipo 'B' ";
    }else if(dato.tipoMovimiento == TipoMovimiento.NDA){
      descripcion += "Nota Debito tipo 'A' ";
    }else if(dato.tipoMovimiento == TipoMovimiento.NDB){
      descripcion += "Nota Debito tipo 'B' ";
    }else{
      descripcion += "Documento ";
    }

    if(dato.condicionVenta == CondicionVentaFactura.contado){
      descripcion += "Contado";
    }else{
      descripcion += "Cuenta Corriente"
    }

    return descripcion;
  }

  getNumeroCompletoComprobante(dato: Balance7ActaDocumentosDTO){
    return dato.prefijo + "-" + dato.proximoNumero;
  }

  getNombreCiudad(){
    return this.nombreCiudad;
  }

  calcularNumeroMes(mes: number){
    if(mes > 12){
      return mes - 12;
    }else{
      return mes;
    }
  }

  calcularProximoCierre(mes: number, anio: number){
    if(mes > 12){
      anio++;
    }

    return anio;
  }


  calculaUltimoDiaMes(){
    switch(this.mes){
      case 1: case 3: case 5: case 7: case 8: case 10: case 12:
        return 31;      
      case 2:
        return 28;
      default:
        return 30;
    }
  }

  print(): void {
    const printContents = document.getElementById('print').innerHTML;
    this.sharedService.print2(printContents);    
  }

  mostrarLoading(){
    this.obteniendoDatos = true;
    this.spinner.show('spinnerActa');
  }

  ocultarLoading(){
    this.obteniendoDatos = false;
    this.spinner.hide('spinnerActa');
  }
}
